import React from 'react';
import styled from '@emotion/styled';
import { CarouselTypeProps } from '../types';
import { SCREEN_BREAKPOINTS } from '../../../constants';

const CarouselAdTypeElement = styled.p`
  margin: 50px 0 15px;
  padding: 0 8%;
  color: #ffffff;
  font-size: 1.8rem;
  line-height: 2.8rem;
  span {
    font-weight: bold;
  }
  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    margin: 26px 0 10px;
    padding: 0;
    font-size: 1.4rem;
    line-height: 1.8rem;
  }
`;

export const CarouselType = ({ adType }: CarouselTypeProps) => {
  return (
    <div>
      <CarouselAdTypeElement>{adType.type}</CarouselAdTypeElement>
      <CarouselAdTypeElement>{adType.description}</CarouselAdTypeElement>
    </div>
  );
};
